// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1___0d74d91bc945d1dd516","cls2":"BulkFollowSuggestion-cls2___1ce167de15828171ab5 BulkFollowSuggestion-cls1___0d74d91bc945d1dd516"};